const StripeTerminalInit = () => {
  const stripeScript = document.createElement('script');
  stripeScript.defer = true;
  stripeScript.setAttribute('src', 'https://js.stripe.com/terminal/v1/');
  stripeScript.setAttribute('crossorigin', 'anonymous');
  document.head.appendChild(stripeScript);
};

export default StripeTerminalInit;
